<script>
  import {
    addressTypesComputed,
    addressTypesMethods,
    countriesComputed,
    countriesMethods,
  } from '@state/helpers'
  import {
    ChevronRightIcon,
    PlusIcon,
    XIcon,
    Edit3Icon,
  } from 'vue-feather-icons'
  import Multiselect from 'vue-multiselect'
  import { ensureOnlyOnePrimary } from '@utils/select-one-primary-object'
  import { getStringFromObjectAddress } from '@utils/format-address';
  import _isEqual from 'lodash/isEqual'
  export default {
    components: {
      Multiselect,
      ChevronRightIcon,
      PlusIcon,
      XIcon,
      Edit3Icon,
    },
    props: {
      formError: {
        type: Object,
        required: true
      },
      addresses: {
        type: Array,
        required: true
      },
      definedAddressTypes: {
        type: Array,
        default: null
      },
      singleOnly:{
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        normalAddressTypes: [],
        innited: {
          addressTypes : false
        }
      }
    },
    computed: {
      ...addressTypesComputed,
      ...countriesComputed,
      addressTypes(){
        if (this.definedAddressTypes){
          return this.definedAddressTypes
        }
        return this.normalAddressTypes
      },
      showAddAddress(){
        if (this.singleOnly && this.addresses.length === 1){
          return false
        }
        if (this.addresses.length > 1 && this.isAddressEmpty(this.addresses[this.addresses.length - 1])){
          return false
        }
        return true
      },
    },
    async created() {
      this.getCountries()
      await this.getAddressTypes()
      this.normalAddressTypes = await this.listAddressTypes.data
    },
    methods: {
      ...addressTypesMethods,
      ...countriesMethods,
      getStringFromObjectAddress,
      ensureOnlyOnePrimary,
      _isEqual,
      tryToSelectOnePrimary(index) {
        this.$nextTick(() => {
          this.ensureOnePrimary(this.addresses, index)
        });
      },
      getAddressData (addressData, placeResultData, id) {
        const idNumber =  Number(id.split('-')[1]);
        this.addresses.forEach((item, index) => {
          if (index === idNumber) {
            Object.keys(this.formError).forEach(key => {
              if (key && key.startsWith('addresses.' + index)) {
                delete this.formError[key];
              }
            })
            const data = this.parseDataAddressData(item, addressData, this.listCountries.data);
            this.$set(this.addresses, index, data)
          }
        });
      },
      addAddress() {
        this.addresses.push(
          {
            types: [],
            is_primary: false,
            country: {},
            is_edit: true,
            is_display: false,
          }
        );
      },
      removeAddress(index) {
        if (this.addresses[index].is_primary && this.addresses.length > 1){
          this.ensureOnlyOnePrimary(this.addresses, index)
        }
        this.addresses.splice(index, 1)
      },
      toggleEditAddress(index, toggle = true) {
        const address = this.addresses[index]
        this.$set(address, 'is_edit', toggle)
        this.$set(address, 'is_display', false)
      },
      canUpdateAddress(index){
        const address = this.addresses[index]
        if (address && (address.country || address.country_id)  && address.line_1 && address.types.length > 0){
          return true
        }
        return false
      },
      canRemove(index){
        const usableAddresses = this.addresses.filter(el => el && (el.country || el.country_id) && el.line_1 && el.types.length > 0)
        const address = this.addresses[index]
        if (usableAddresses && usableAddresses.length > 0){
          const indexInUsableAddr = (usableAddresses.findIndex(el => this._isEqual(el, address)) !== -1)
          if (!indexInUsableAddr){
            return true
          }
          if (indexInUsableAddr &&  usableAddresses.length > 1){
            return true
          }
        }else{
          if (this.addresses.length > 1 && this._isEqual(this.addresses[this.addresses.length - 1], address)){
            return true
          }
        }
        return false
      },
      isAddressEmpty(address){
        if (address.country_id || address.line_1 || (address.types && address.types.length > 0) ){
          return false
        }
        return true
      },
      parseAddressValidation(validation, index) {
        return {
          line_1: validation['addresses.' + index + '.line_1'] || null,
          suburb: validation['addresses.' + index + '.suburb'] || null,
          state: validation['addresses.' + index + '.state'] || null,
          city: validation['addresses.' + index + '.city'] || null,
          postcode: validation['addresses.' + index + '.postcode'] || null,
          country_id: validation['addresses.' + index + '.country_id'] || null,
        }
      },
      isValid(address){
        if(address && address.types && address.types.length > 0 && (address.country || address.country_id) && address.line_1){
          return true
        }
        return false
      },
      isIndexErrorResolved(index){
        const indexSpecificRegex = new RegExp(`addresses.${index}`, "g");
        for (const [key] of Object.entries(this.formError)) {
          if (key.match(indexSpecificRegex)){
            const section = key.split('.')[2] // 'types' || 'line_1'
            const sectionObject = this.addresses[`${index}`][`${section}`]
            if(! (sectionObject && sectionObject.length > 0)){
              return false
            }
          }
        }
        return true
      },
      hasAnyError(index){
        const indexSpecificRegex = new RegExp(`addresses.${index}`, "g");
        if (Object.entries(this.formError).findIndex(el => el[0].match(indexSpecificRegex)) !== -1){
          return true
        }
        return false
      },
      getErrorMessageCollection(index){
        const retval = []
        const indexSpecificRegex = new RegExp(`addresses.${index}`, "g");
        for (const [key, value] of Object.entries(this.formError)) {
          if (key.match(indexSpecificRegex)){
            retval.push(value)
          }
        }
        return retval
      },
      resolveMessageIndex(index, messageIndex){
        return `${index}_errorMessage_${messageIndex}`
      },
      toggleDisplayMoreAddress(index){
        const address = this.addresses[index]
        this.$set(address, 'is_display', !address.is_display)
      },
    }
  };
</script>
<template>
  <div class="form-block tw-mt-2">
    <div v-for="(address, index) in addresses" :key="index">
      <div
        v-if="!address.is_edit"
        class="edit-form-item tw-flex-col md:tw-flex tw-mt-2 tw-mb-3"
        :class="{
          'border-col-error': (!isValid(address) || hasAnyError(index)) && !isIndexErrorResolved(index),
          'md:tw-pr-12': !canRemove(index),
          'tw-pr-[8.5rem] md:tw-pr-24': canRemove(index),
        }">
        <div
          class="item-info !tw-h-11"
          :class="{ 'tw-border-b': address.is_display }">
          <div class="tw-w-full md:tw-w-8/12 tw-px-4 left-ct tw-flex tw-items-center">
            <span v-if="address.is_primary" class="block-status border rounded-pill pl-1 mr-2 md:tw-hidden tw-flex">
              <span class="status-icon status-completed" style="margin-right: 0.25rem;"/>
            </span>
            <p class="tx-value mg-b-0 text-bold tw-truncate">{{ getStringFromObjectAddress(address, listCountries.data) }}</p>
          </div>
          <div class="tw-w-0 md:tw-w-4/12 right-ct fl-inline ovf-x-hide tw-hidden md:tw-block">
            <span v-if="address.is_primary" class="block-status border rounded-pill pl-1 pr-3 mr-2  md:tw-flex tw-hidden">
              <span class="status-icon status-completed"></span><span class="status-text">Primary</span>
            </span>
            <span v-for="(type, typeIndex) in address.types" :key="typeIndex" class="tw-hidden md:tw-block">
              <span v-if="typeIndex < 1 || !address.is_primary && typeIndex < 2" class="block-status border rounded-pill pl-3 pr-3 mr-2">
                <span class="status-text">
                  <span v-if="type">{{type.name}}</span>
                </span>
              </span>
              <span v-else-if="(typeIndex >= 2 || (address.is_primary && typeIndex >= 1)) && (typeIndex === address.types.length - 1)">
                <span class="status-text">More...</span>
              </span>
            </span>
          </div>
          <div
            class="action-group mg-l-auto !tw-h-11"
            :class="{ 'tw-border-b tw-border-gray-300': address.is_display }">
            <button
              class="tw-group btn btn-icon button-action button-action-active tw-block md:tw-hidden"
              @click="toggleDisplayMoreAddress(index)">
              <BaseChevronRotate
                transition-class="rotate-360-180"
                double
                size="1.2x"
                :toggle="!!address.is_display"
                :duration="500"
                class="tw-text-black group-hover:tw-text-white"
              />
            </button>
            <button
              class="btn btn-icon button-action button-action-positive"
              :class="{
                '!tw-rounded-br-none': (!canRemove(index) && address.is_display),
              }"
              @click="toggleEditAddress(index)">
              <Edit3Icon size="1x" />
            </button>
            <button
              v-if="canRemove(index)"
              class="btn btn-icon button-action button-action-negative"
              :class="{
                '!tw-rounded-br-none': address.is_display,
              }"
              @click="removeAddress(index)">
              <XIcon size="1x" />
            </button>
          </div>
        </div>
        <FabricCollapse
          :id="'address-detail-collapse-' + index"
          v-model="address.is_display"
          hide-header
          :duration="500"
          class="tw-w-full md:tw-hidden show tw-justify-start">
          <div
            class="tw-px-5 tw-flex tw-flex-col tw-text-base tw-py-1"
            :class="{
              'tw-mr-[-22px]': !canRemove(index),
              'tw--mr-36': canRemove(index),
            }">
            <section v-if="address.line_1" class="tw-flex tw-flex-col xs:tw-flex-row tw-justify-between">
              <span class="tw-w-full xs:tw-w-2/5">Street:</span>
              <span class="tw-w-full xs:tw-w-3/5 tw-pl-2 xs:tw-pl-0 tw-pb-2 xs:tw-pb-0 xs:tw-text-right tw-overflow-ellipsis tw-truncate">{{address.line_1}}</span>
            </section>
            <section v-if="address.suburb" class="tw-flex tw-flex-col xs:tw-flex-row tw-justify-between">
              <span class="tw-w-full xs:tw-w-2/5">Suburb:</span>
              <span class="tw-w-full xs:tw-w-3/5 tw-pl-2 xs:tw-pl-0 tw-pb-2 xs:tw-pb-0 xs:tw-text-right tw-overflow-ellipsis tw-truncate">{{address.suburb}}</span>
            </section>
            <section v-if="address.postcode" class="tw-flex tw-flex-col xs:tw-flex-row tw-justify-between">
              <span class="tw-w-full xs:tw-w-2/5">Postcode:</span>
              <span class="tw-w-full xs:tw-w-3/5 tw-pl-2 xs:tw-pl-0 tw-pb-2 xs:tw-pb-0 xs:tw-text-right tw-overflow-ellipsis tw-truncate">{{address.postcode}}</span>
            </section>
            <section v-if="address.state" class="tw-flex tw-flex-col xs:tw-flex-row tw-justify-between">
              <span class="tw-w-full xs:tw-w-2/5">State:</span>
              <span class="tw-w-full xs:tw-w-3/5 tw-pl-2 xs:tw-pl-0 tw-pb-2 xs:tw-pb-0 xs:tw-text-right tw-overflow-ellipsis tw-truncate">{{address.state}}</span>
            </section>
            <section v-if="address.country && address.country.name" class="tw-flex tw-flex-col xs:tw-flex-row tw-justify-between">
              <span class="tw-w-full xs:tw-w-2/5">Country:</span>
              <span class="tw-w-full xs:tw-w-3/5 tw-pl-2 xs:tw-pl-0 tw-pb-2 xs:tw-pb-0 xs:tw-text-right tw-overflow-ellipsis tw-truncate">{{address.country.name}}</span>
            </section>
            <template v-if="address.types && address.types.length > 0">
              <span class="tw-w-full sm:tw-w-3/12">Types:</span>
              <span v-for="(type, typeIndex) in address.types" :key="typeIndex" class="tw-truncate">
                <ChevronRightIcon size="1.2x" class="mg-r-5 stroke-blue no-hover tw-inline-flex"/>{{type.name}}
              </span>
            </template>
          </div>
        </FabricCollapse>
      </div>
      <section v-if="hasAnyError(index) && !address.is_edit && !isIndexErrorResolved(index)" class="-tw-mt-2.5 tw-mb-3">
        <p
          v-for="(message, messageIndex) in getErrorMessageCollection(index)"
          :key="resolveMessageIndex(index, messageIndex)"
          class="text-danger">
          {{ message }}
        </p>
      </section>
      <div v-show="address.is_edit" class="border border-radius-20 tw-mt-2 tw-mb-3 pd-20 bg-gray">
        <div class="group-block">
          <BaseAddressLookup
            :id="`addresses-${index}`"
            inline-validation
            :address="address"
            :validation="parseAddressValidation(formError, index)"
            @changed="getAddressData"
          />
          <div :class="['form-group tw-mb-2', { 'is-invalid': formError['addresses.' + index + '.types'] || (index === 0 && innited.addressTypes && !(address.types && address.types.length > 0)) }]">
            <label class="label-control">Address Type</label>
            <div v-if="addressTypes" class="tw-flex tw-flex-col md:tw-flex-row tw-items-start tw-justify-between">
              <div class="tw-w-full md:tw-w-9/12" :class="{ 'is-invalid': formError['addresses.' + index + '.types'] || (index === 0 && innited.addressTypes && !(address.types && address.types.length > 0)) }">
                <Multiselect
                  :id="`address-types-${index}`"
                  v-model="addresses[index].types"
                  :multiple="true"
                  :class="{
                    'scrollable': addressTypes.length > 7,
                  }"
                  :options="addressTypes"
                  label="name"
                  track-by="name"
                  @input="index === 0 ? innited.addressTypes = true : ''"
                />
              </div>
              <div class="tw-w-full md:tw-w-2/12 tw-pt-2.5 switch-button-custom">
                <FabricCheckbox
                  v-model="addresses[index].is_primary"
                  :disabled="addresses[index].is_primary"
                  slot-classes="!tw-pl-3 tw-text-black"
                  switch
                  @update="tryToSelectOnePrimary(index)"
                >Primary</FabricCheckbox>
              </div>
            </div>
            <div v-if="formError" class="tw-pt-1 md:tw-pt-0">
              <p v-if="formError[`addresses.${index}.types`] || (index === 0 && innited.addressTypes && !(address.types && address.types.length > 0))" class="text-danger">{{ formError[`addresses.${index}.types`] }}</p>
            </div>
          </div>
        </div>
        <div class="xs:tw-flex-row tw-flex tw-flex-col tw-items-center tw-justify-between tw-pt-3">
          <button
            v-if="canRemove(index)"
            type="button"
            class="btn button button-dashed-danger xs:tw-mb-0 tw-w-5/12 xs:tw-w-px tw-mb-3"
            @click="removeAddress(index)">
            Remove
          </button>
          <span v-else/>
          <button
            type="button"
            :disabled="!canUpdateAddress(index)"
            class="btn button button-dashed-positive xs:tw-mb-0 tw-w-5/12 xs:tw-w-px"
            @click="toggleEditAddress(index, false)">
            Update
          </button>
        </div>
      </div>
    </div>
    <div v-if="showAddAddress" class="group-button mt-3">
      <button class="btn button-bd-dashed" @click="addAddress">
        <div class=" fl-al-center">
          <PlusIcon size="1.5x" class="custom-class float-left mr-2"></PlusIcon>
          <span class="item-text">Add Address</span>
        </div>
      </button>
    </div>
    <p v-if="formError && formError.addresses" class="text-danger">{{ formError.addresses }}</p>
  </div>
</template>
